<template lang='pug'>
  .templates
    | Templates
</template>

<script>
  // import store from 'store/index'
  // import scope_object from 'services/scope_object'

  export default {
    name: 'template_selector',
    data() {
      return {
        brand: scope_object.current_brand,
        templates: []
      }
    },
    computed: {

    },
    methods: {
      fetch_templates (brand) {
        const find_options = {}
        if (brand) find_options.basePath = brand.resource_url
        store.findAll('template', {
          fields: ['landing_pages', 'landing_pages.landing_page_widgets']
        }, find_options).then((templates) => {
          this.templates.push(...templates)
        })
        .catch((e) => {
          console.log(e)
        })
      }
    },
    mounted() {
      this.fetch_templates(this.brand)
    }

  }

</script>

<style lang='scss' scoped>

</style>
